import React from "react";
import "./button.scss";
import classNames from "classnames";
import { motion } from "framer-motion";

interface ButtonProps {
  color: string;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
}

export default function Button(props: ButtonProps) {
  return (
    <button
      onClick={props.onClick}
      className={classNames({
        button: true,
        [`button-${props.color}`]: props.color,
      })}
    >
      {props.children}
    </button>
  );
}

interface AnswerButtonProps {
  chosen?: Boolean;
  type?: String;
  showStatus?: Boolean;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent) => void;
}

export function AnswerButton(props: AnswerButtonProps) {
  const item = {
    hidden: { scale: 0, y: 25 },
    show: {
      scale: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "circOut",
      },
    },
  };
  return (
    <motion.button
      variants={item}
      onClick={props.onClick}
      className={classNames({
        button: true,
        "button-answer": true,
        [`answer-${props.type}`]: props.type,
        "answer-selected": props.chosen,
      })}
    >
      {props.children}
    </motion.button>
  );
}
